export const WOOCOMMERCE = 'woocommerce'
export const MAGENTO = 'magento'
export const SHOPIFY = 'shopify'
export const ONGOING = 'ongoing'
export const VISKAN = 'viskan'
